<!--签署方信息错误提示 1.填写企业证件号，2.对填写的姓名身份证号进行二要素验证错误-->
<template>
  <!--批量发起弹窗-->
  <div>
    <el-dialog title="信息提示"
               :visible.sync="visibleCredit"
               :close-on-click-modal="false"
               width="730px"
               class="add-ent-id"
               @open="openDialog"
               @close="closeDialog">
      <div class="box-main">
        <p class="err-title"><img src="../../static/images/warning.png">以下数据填写错误或无数据，请核实，若是海外企业请前往国际版发起！</p>

        <el-form :model="entCreditJson" ref="ruleForm" label-width="100px" class="twoColumn">
          <!--企业名称的错误-->
          <template v-if="entCreditArr && entCreditArr.length">
            <div class="myRow" v-for="(item,index) in entCreditArr" :key="`ent${index}`">
              <el-form-item label="公司名称：">
                <el-input size="small" :value="item" :placeholder="item" :disabled="true"/>
              </el-form-item>
              <el-form-item label="营业执照号：" :prop="item" :rules="rules.businessLicenseNo">
                <el-input v-model="entCreditJson[item]" size="small" placeholder="请输入"/>
              </el-form-item>
            </div>
          </template>

          <!--姓名身份证号二要素验证错误-->
          <template v-if="userIdentityInfoArr && userIdentityInfoArr.length">
            <div class="myRow" v-for="(item,index) in userIdentityInfoArr" :key="`user${index}`">
              <el-form-item label="姓名：">
                <el-input size="small" :value="item.name"  placeholder="姓名" :disabled="true"/>
              </el-form-item>
              <el-form-item label="身份证号码：">
                <el-input  size="small" :value="item.identityNo" placeholder="中国大陆身份证号码" :disabled="true"/>
              </el-form-item>
            </div>
          </template>

        </el-form>

      </div>
      <div slot="footer" class="dailog-footer" style="margin-top: 20px;">
        <el-button @click="sureFn" size="small" class="btn">{{sureText}}</el-button>
        <el-button @click="$emit('cancel')" type="danger" size="small" class="btn">{{cancelText}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {
      show: {
        type: Boolean,
        default: false
      },
      // 企业信息 satrt
      entCreditArr:{
        type: Array,
        default(){
          return [] // [entName,entName,....]
        }
      },
      entCreditJson:{
        type: Object,
        default(){
          return {}
        }
      },
      // 个人信息
      userIdentityInfoArr:{
        type: Array,
        default(){
          return [] // [{name:xx,identityNo:xx},{name:xx,identityNo:xx},.....]姓名和身份证号组成的数组
        }
      },
      sureText:{
        type:String,
        default:'继续发起'
      },
      cancelText:{
        type:String,
        default:'返回修改'
      }
    },
    data() {
      return {
        visibleCredit: false,
        rules: {
          businessLicenseNo: [
            {required: true, message: '营业执照号不能为空', trigger: ['change', 'blur']},
            {validator: this.$validator.businessLicenseVal, trigger: ['change', 'blur']},
          ],
        }
      }
    },
    computed: {
    },
    methods: {
      openDialog() {
        this.$emit('update:show', true)
      },
      closeDialog() {
        this.$emit('update:show', false)
      },
      sureFn(){
        this.$refs['ruleForm'].validate((valid) => {
          if (!valid) return false
          // 继续发起
          this.$emit('continue')
        });
      }
    },
    created() {
      this.visibleCredit = this.show
    },
    watch: {
      show(newVal) {
        this.visibleCredit = newVal
      }
    },
    name: "batchLaunch"
  }
</script>

<style lang="less" scoped>
  .add-ent-id {
    .box-main {
      max-height: 480px;
      overflow: auto;
      .err-title{
        font-size: 16px;
        font-family: Source Han Sans SC;
        color: #290202;
        margin: 20px 0;
        img{
          vertical-align: middle;
          width: 15px;
          height: 15px;
          margin-right: 5px;
          display: inline-block;
        }
      }
    }

    .ent-input {
      margin-bottom: 10px;
    }
  }

  .twoColumn{
    .myRow{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    /deep/ .el-form-item{
      margin-bottom: 18px;
      flex: 1;
      &:first-child{
        margin-right: 10px;
      }
      .el-form-item__label{
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #290202;
        padding-right: 0;
      }
      .el-input__inner{
        box-sizing: border-box;
        height: 35px;
        line-height: 35px;
        text-align: left;
      }
      .el-form-item__error{
        top: 90%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// components/contract/signInfoTipsDialog.vue